import { SimpleGrid, SimpleGridProps } from "@chakra-ui/react";
import { FC } from "react";

const ArticleGrid: FC<SimpleGridProps> = ({ children, ...rest }) => {
  return (
    <SimpleGrid
      columns={{ base: 1, md: 3, xl: 4 }}
      gap={{ base: 6, md: 10 }}
      mx="auto"
      {...rest}
    >
      {children}
    </SimpleGrid>
  );
};

export default ArticleGrid;
